import axiosVerbose from './axios/axiosVerbose'
import { logError } from './errors'

export const getSimilarItems = (
  itemId: number,
  site: string | null = null,
  pageSize = 8
) => {
  const siteFilter = site ? `&site=${site}` : ''
  const url =
    `/shopfront-api/search/similar?item_id=${itemId}&page_size=${pageSize}` +
    siteFilter

  return axiosVerbose
    .get(url)
    .then(res => res.data)
    .catch(err => Promise.reject(logError(err)))
}
